import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CLASSIC_CHAIN_ID, FACTORY_ADDRESS } from "utils/Constants";
import { useAsset } from "./AssetProvider";
import { lcd } from "utils/Helpers";
import { useWallet } from "./WalletProvider";

type Pages = "registerToken" | "stakedAsset" | "rewards" | "managePool" | "stakingConfig" | "feeConfig";

const PagePermissionContext = createContext({
    registerToken: false,
    stakedAsset: false,
    rewards: false,
    managePool: false,
    stakingConfig: false,
    feeConfig: false
});

export const usePagePermission = () => useContext(PagePermissionContext)

export function PagePermissionProvider({ children }: { children: ReactNode }) {
    const [permissions, setPermissions] = useState({
        registerToken: false,
        stakedAsset: false,
        rewards: false,
        managePool: false,
        stakingConfig: false,
        feeConfig: false,
    });

    const [isAdmin, setIsAdmin] = useState(false)
    const { address } = useWallet()
    const { stakingAddress, tokenInfo, owner } = useAsset()

    useEffect(() => {
        const isConnected = address != undefined
        const isAssetSelected = stakingAddress != undefined && tokenInfo != undefined;
        const isOwner = owner == address

        const permissions = {
            registerToken: isConnected,
            stakedAsset: isConnected && isAssetSelected,
            rewards: isConnected && isAssetSelected,
            managePool: isConnected && isAssetSelected && isOwner,
            stakingConfig: isConnected && isAssetSelected && isOwner,
            feeConfig: isAdmin
        };
        setPermissions(permissions)
    }, [isAdmin, stakingAddress, tokenInfo, owner, address])

    useEffect(() => {
        if (address) loadContractInfo()
    }, [address])


    const loadContractInfo = async () => {
        const contractInfo = await lcd.wasm.contractInfo(FACTORY_ADDRESS)
        setIsAdmin(contractInfo.admin == address)
    }

    return <PagePermissionContext.Provider value={permissions}>
        {children}
    </PagePermissionContext.Provider>
}